<template>
  <div>
    <!-- <p>{{ jobs }}</p> -->
    <table class="web-only table table-striped mt-2 mb-5">
      <thead class style="background-color: var(--nannycogreen); color: #fff;">
        <tr class>
          <th scope="col">Date</th>
          <th scope="col">Family</th>
          <th scope="col">Start Time</th>
          <th scope="col">End Time</th>
          <th scope="col">Status</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="job in jobs" :key="job.id" style="cursor: pointer">
          <td>{{ new Date(job.date).toDateString() }}</td>
          <td>{{ job.poster_name }}</td>
          <td>
            <span v-if="job.status == 'Approved'">{{ djangotimeformatAMPM(job.start_time) }}</span>
            <span v-else>{{ djangotimeformatAMPM(job.actual_start_time) }}</span>
            <!-- <span v-if="job.status == 'In Progress'">{{ djangotimeformatAMPM(job.actual_start_time) }}</span> -->
          </td>
          <td>
            <span v-if="job.status == 'Approved'">{{ djangotimeformatAMPM(job.end_time) }}</span>
            <span v-else>{{ djangotimeformatAMPM(job.actual_end_time) }}</span>
          </td>
          <td>{{ job.status }}</td>
          <td>
            <router-link
              :to="{ name: 'Job', params: { id: job.id } }"
              class="mylisting-button dark-button"
              target="_blank"
            >View Job Listing</router-link>
            <button v-if="job.status == 'Approved'" class="mylisting-button dark-button" @click="showClockInModal(job)">Clock In</button>
            <button v-if="job.status == 'In Progress'" class="mylisting-button dark-button" @click="showClockOutModal(job)">Clock Out</button>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-for="job in jobs" :key="job.id" class="mobile-only mt-3">
      <h4>{{ job.poster_name }} - {{ new Date(job.date).toDateString() }}</h4>
      <hr>
      <p v-if="job.status == 'Approved'">Start Time: {{ djangotimeformatAMPM(job.start_time) }}</p>
      <p v-else>Start Time: {{ djangotimeformatAMPM(job.actual_start_time) }}</p>
      <p v-if="job.status == 'Approved'">End Time: {{ djangotimeformatAMPM(job.end_time) }}</p>
      <p v-else>End Time: {{ djangotimeformatAMPM(job.actual_end_time) }}</p>
      <pre v-if="job.text">Special Notes: {{ job.text }}</pre>
      <p class="mb-1">Current Status: {{ job.status }}</p>
      <router-link
        :to="{ name: 'Job', params: { id: job.id } }"
        class="mylisting-button dark-button"
        target="_blank"
      >View Job Listing</router-link>
      <button v-if="job.status == 'Approved'" class="mylisting-button dark-button" @click="showClockInModal(job)">Clock In</button>
      <button v-if="job.status == 'In Progress'" class="mylisting-button dark-button" @click="showClockOutModal(job)">Clock Out</button>
      <hr>
    </div>

    <modal name="clockin-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h4>Ready to Begin?</h4>
        <hr>
        <h5>Family: {{ job.poster_name }}</h5>
        <p>{{ new Date().toDateString() }}</p>
        <h4>{{ formatAMPM( currentTime ) }}</h4>
        <textarea rows="5" v-model="notes" class="form-control mt-3" placeholder="Any notes?"></textarea>
        <hr>
        <button class="mylisting-button secondary-button mb-2" @click="$modal.hide('clockin-modal')">Cancel</button>
        <button class="mylisting-button dark-button" @click="clockin()">Clock In</button>
      </div>
    </modal>

    <modal name="clockout-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h4>Finished?</h4>
        <hr>
        <h5>Family: {{ job.poster_name }}</h5>
        <p>{{ new Date().toDateString() }}</p>
        <h4>{{ formatAMPM( currentTime ) }}</h4>
        <textarea rows="5" v-model="notes" class="form-control mt-3" placeholder="Any notes?"></textarea>
        <hr>
        <button class="mylisting-button secondary-button mb-2" @click="$modal.hide('clockout-modal')">Cancel</button>
        <button class="mylisting-button dark-button" @click="clockout()">Clock Out</button>
      </div>
    </modal>

    <modal name="successful-clockin-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h4>Thanks!</h4>
        <h5>Hope the job goes well, don't forget to clock out when you are finished!</h5>
        <hr>
        <button class="mylisting-button secondary-button mb-2" @click="$modal.hide('successful-clockin-modal')">Done</button>
      </div>
    </modal>

    <modal name="successful-clockout-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h4>Thanks!</h4>
        <h5>If there were any issues with recording the time, or anything else, please let us know.</h5>
        <hr>
        <button class="mylisting-button secondary-button mb-2" @click="$modal.hide('successful-clockout-modal')">Done</button>
      </div>
    </modal>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      jobs: [],
      job: {},
      notes: '',

      currentTime: new Date(), // https://stackoverflow.com/questions/57249466/getting-current-time-and-date-in-vue-js
    }
  },
  created() {
    this.getJobs()

    setInterval(this.getCurrentTime, 1000); // Keep updating the current time every second
  },
  methods: {
    getJobs() {
      axios.get(`/api/jobs/?agency=${this.$store.getters.agencyID}&filler=${this.user.id}`)
        .then(res => {
          console.log(res)
          this.jobs = res.data

          // this.calendarJobs = []
          // for (var job in this.jobs) {
          //   console.log('dsgjaklsjl;kds')
          //   // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'title': `${this.jobs[job].start_time} - ${this.jobs[job].end_time}`})
          //   this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
          // }
        })
        .catch(error => {
          console.log(error)
        })
    },
    showClockInModal(job) {
      this.job = job
      this.$modal.show('clockin-modal')
    },
    clockin() {
      let now = new Date();
      axios.patch(`/api/jobs/${this.job.id}/`, {
        actual_start_time:
          now.getHours().toString() +
          ":" +
          now.getMinutes().toString() +
          ":00",
        status: "In Progress",
        text3: this.notes,
      })
        .then(res => {
          this.getJobs()
          this.$modal.hide('clockin-modal')
          this.$modal.show('successful-clockin-modal')
        })
        .catch(error => console.log(error))
    },
    showClockOutModal(job) {
      this.job = job
      this.notes = job.notes
      this.$modal.show('clockout-modal')
    },
    clockout() {
      let now = new Date();
      axios.patch(`/api/jobs/${this.job.id}/`, {
        actual_end_time:
          now.getHours().toString() +
          ":" +
          now.getMinutes().toString() +
          ":00",
        status: "Completed",
        text3: this.notes,
      })
        .then(res => {
          this.getJobs()
          this.$modal.hide('clockout-modal')
          this.$modal.show('successful-clockout-modal')
        })
        .catch(error => console.log(error))
    },
    getCurrentTime() {
      // https://stackoverflow.com/questions/57249466/getting-current-time-and-date-in-vue-js
      this.currentTime = new Date();
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/jobs/MyJobs.vue